export const isEmptyArray = (arr: unknown[] | undefined) => {
  return arr?.length === 0
}